let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hUJ4u")).then(() => parcelRequire('fNRM8'));